var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:arrow-up-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.96971 3.21959C3.82911 3.36024 3.75012 3.55097 3.75012 3.74984C3.75012 3.94871 3.82911 4.13944 3.96971 4.28009L7.68221 7.99259L3.96971 11.7051C3.83309 11.8465 3.7575 12.036 3.75921 12.2326C3.76092 12.4293 3.83979 12.6174 3.97885 12.7565C4.11791 12.8955 4.30601 12.9744 4.50266 12.9761C4.69931 12.9778 4.88876 12.9022 5.03021 12.7656L9.27296 8.52284C9.41357 8.38219 9.49255 8.19146 9.49255 7.99259C9.49255 7.79372 9.41357 7.60299 9.27296 7.46234L5.03021 3.21959C4.88957 3.07899 4.69884 3 4.49996 3C4.30109 3 4.11036 3.07899 3.96971 3.21959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.21959 3.21959C8.07899 3.36024 8 3.55097 8 3.74984C8 3.94871 8.07899 4.13944 8.21959 4.28009L11.9321 7.99259L8.21959 11.7051C8.08297 11.8465 8.00738 12.036 8.00909 12.2326C8.01079 12.4293 8.08967 12.6174 8.22873 12.7565C8.36778 12.8955 8.55589 12.9744 8.75254 12.9761C8.94919 12.9778 9.13864 12.9022 9.28009 12.7656L13.5228 8.52284C13.6634 8.38219 13.7424 8.19146 13.7424 7.99259C13.7424 7.79372 13.6634 7.60299 13.5228 7.46234L9.28009 3.21959C9.13945 3.07899 8.94871 3 8.74984 3C8.55097 3 8.36024 3.07899 8.21959 3.21959Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowHide);
export default __webpack_public_path__ + "static/media/arrowHide.8b60bb4092050f641812fb334475fbb2.svg";
export { ForwardRef as ReactComponent };